<template>
  <div class="modal-wrapper" ref="modal-wrapper">
    <div class="blur-background"></div>
    <div class="share cardboard">
      <button
        class="share__close"
        @click="close"
        aria-label="close"
        role="button"
      >
        <CloseAnimation />
      </button>

      <p class="share__title">Share the experience</p>
      <div class="share__list">
        <a
          :href="'https://www.facebook.com/sharer/sharer.php?u=' + url"
          class="share__icon icon-facebook"
        ></a>
        <a
          :href="'https://twitter.com/home?status=' + url"
          class="share__icon icon-twitter"
        ></a>
        <a @click="copyurl" class="share__icon icon-link"></a>
      </div>
      <p class="share__title">Follow Old Dominion</p>
      <div class="share__list">
        <a
          href="https://www.facebook.com/olddominionband/"
          rel="noreferrer noopener"
          target="_blank"
          class="share__icon icon-facebook"
        ></a>
        <a
          href="https://instagram.com/olddominionmusic/"
          rel="noreferrer noopener"
          target="_blank"
          class="share__icon icon-instagram"
        ></a>
        <a
          href="https://twitter.com/olddominion"
          rel="noreferrer noopener"
          target="_blank"
          class="share__icon icon-twitter"
        ></a>
        <a
          href="https://od.lnk.to/profileAW/tiktok"
          rel="noreferrer noopener"
          target="_blank"
          class="share__icon icon-tiktok"
        ></a>
        <a
          href="https://www.youtube.com/channel/UC0i6gIMXKhpAftcblKCgqKA"
          rel="noreferrer noopener"
          target="_blank"
          class="share__icon icon-youtube"
        ></a>
      </div>
      <p class="share__title">Stream</p>
      <div class="share__list">
        <a
          href="https://od.lnk.to/TTTAW/spotify"
          class="share__icon icon-spotify"
          rel="noreferrer noopener"
          target="_blank"
        ></a>
        <a
          href="https://od.lnk.to/TTTAW/itunes"
          class="share__icon icon-apple-music"
          rel="noreferrer noopener"
          target="_blank"
        ></a>
        <a
          href="https://od.lnk.to/TTTAW/youtubemusic"
          class="share__icon icon-youtube-music"
          rel="noreferrer noopener"
          target="_blank"
        ></a>
        <a
          href="https://od.lnk.to/TTTAW/pandora"
          class="share__icon icon-pandora"
          rel="noreferrer noopener"
          target="_blank"
        ></a>
        <a
          href="https://od.lnk.to/TTTAW/amazonmusic"
          class="share__icon icon-amazon"
          rel="noreferrer noopener"
          target="_blank"
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
import CloseAnimation from "@/components/animations/CloseAnimation.vue";

export default {
  components: {
    CloseAnimation,
  },
  data() {
    return {
      url: window.location.href,
    };
  },
  mounted() {
    this.$refs["modal-wrapper"].addEventListener("click", (e) => {
      const isOutside = !e.target.closest(".share");
      if (isOutside) this.close();
    });
  },
  methods: {
    close() {
      this.$emit("close");
      document.getElementsByTagName("body")[0].classList.remove("no-scroll");
    },
    copyurl() {
      const el = document.createElement("textarea");
      el.value = this.url;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);

      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 2300);
    },
  },
};
</script>
